function o(c, t, r) {
  const n = c[t];
  if (n !== void 0) return n;
  const e = r();
  return c[t] = e, e;
}
export {
  o as c
};
